import { useEffect, useState } from "react";
import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import eyeBlackIcon from "assets/img/icons/eye-icon-black.svg";
import eyeIcon from "assets/img/icons/eye-icon.svg";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import ButtonWhiteSmall from "components/buttons/ButtonWhiteSmall";

const EmailTemplates = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
  align-self: center;
`;

const TemplatesInfo = styled.div`
  width: 100%;
`;

const TemplateList = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Template = styled.div`
  width: 100%;
  max-width: 400px;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BoxHeader = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

const TemplateName = styled.div`
  padding-top: 4px;
  padding-bottom: 7px;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
  overflow-wrap: anywhere;

  @media (max-width: ${globalConstants.switchMobile}) {
    padding-top: 0px;
  }
`;

const OpenIconWrap = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
`;

const TemplatePreview = styled.div`
  position: relative;
  width: 100%;
`;

const TemplatePreviewImage = styled.div`
  width: 100%;

  border-radius: ${css.BOX_RADIUS_SECONDARY};

  overflow: hidden;
`;

const LargeTemplate = styled.div`
  width: 100%;
  max-width: 560px;

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const PreviewButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${css.BUTTONS_GAP_SMALL};
`;

export default ({
  data,
  onOpenPreviewClick,
  previewOpened,
  closePreview,
  previewing,
  loadTemplate,
}) => {
  const list = data.emailTemplatesData.map((template) => {
    const { id, name, preview_image } = template;

    return (
      <Template key={id}>
        <BoxHeadWrapper>
          <BoxHeader>
            <TemplateName>{name}</TemplateName>
          </BoxHeader>
        </BoxHeadWrapper>
        <TemplatePreview>
          <OpenIconWrap>
            <ButtonRoundIcon
              icon={eyeBlackIcon}
              hoverIcon={eyeIcon}
              background={css.BRAND_YELLOW}
              hoverBackground={css.BRAND_GREEN}
              onClick={() => onOpenPreviewClick(id)}
              buttonSize="32px"
              iconSize="14px"
            />
          </OpenIconWrap>
          <TemplatePreviewImage>
            <img
              src={`/assets-public/img/email-template-previews/${preview_image}`}
              style={{ width: "100%" }}
            />
          </TemplatePreviewImage>
        </TemplatePreview>
      </Template>
    );
  });

  let html = "";
  let design = "";

  if (previewOpened) {
    const previewTemplate = data.emailTemplatesData.find(
      (template) => template.id === previewing
    );
    console.log("previewTemplate", previewTemplate);

    if (previewTemplate) {
      html = previewTemplate.html;
      design = previewTemplate.design;
    }
  }

  return (
    <>
      {!previewOpened && (
        <EmailTemplates>
          <TemplatesInfo>
            Select a ready-made template and insert it into the editor, where
            you will be able to customize it.
          </TemplatesInfo>
          <TemplateList>{list}</TemplateList>
        </EmailTemplates>
      )}
      {previewOpened && (
        <EmailTemplates>
          <LargeTemplate>
            <TemplatePreview>
              <TemplatePreviewImage>
                <div
                  style={{
                    width: "100%",
                    height: "560px",
                    overflow: "auto",
                    border: "1px solid #ccc",
                    background: "#fff",
                  }}
                  className="template-html-preview"
                  dangerouslySetInnerHTML={{ __html: html }}
                />
              </TemplatePreviewImage>
            </TemplatePreview>
          </LargeTemplate>
          <PreviewButtons>
            <ButtonWhiteSmall onClick={closePreview}>Back</ButtonWhiteSmall>
            <ButtonPrimarySmall onClick={() => loadTemplate(design)}>
              Use This Template
            </ButtonPrimarySmall>
          </PreviewButtons>
        </EmailTemplates>
      )}
    </>
  );
};
